var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalGroupBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F4F4F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.858 15.56l6.748-2.891a1 1 0 01.788 0l6.748 2.892a.75.75 0 010 1.378l-6.748 2.892a1 1 0 01-.788 0l-6.748-2.892a.75.75 0 010-1.378z",
    stroke: "#3C3F47",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 18.125l-2.61.87a.75.75 0 00-.085 1.389l6.64 3.161a1 1 0 00.86 0l6.64-3.162a.75.75 0 00-.086-1.388l-2.609-.87",
    stroke: "#3C3F47",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 21.875l-2.61.87a.75.75 0 00-.085 1.389l6.64 3.161a1 1 0 00.86 0l6.64-3.162a.75.75 0 00-.086-1.388l-2.609-.87",
    stroke: "#3C3F47",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/personal_group_big.ee3c4d8c.svg";
export { SvgPersonalGroupBig as ReactComponent };